<template>
    <div>
        <el-row>
            <el-col style="width: 120px;overflew: hidden;" v-for="(item, index) in groupMemberList" :key="index">
                <div class="group-member">
                <UserAvatar class="avatar" :url="item.avatar" :name="item.nickName"/>
                <div v-if="item.removeGroupMemberAuth" class="el-icon-remove group-member-remove-btn" @click="removeMember(item)"></div>
                <div class="name"><span class="value">{{item.nickName}}</span></div>
                </div>
            </el-col>
            <el-col style="width: 40px; height: 40px; position: relative;" v-if="addGroupMemberAuth">
                <el-button class="group-member-add-btn" type="primary" icon="el-icon-plus" @click="addGroupMemberVisible=true"></el-button>
            </el-col>
        </el-row>
        <!-- 添加团队成员 -->
        <el-dialog title="添加团队成员" :visible.sync="addGroupMemberVisible" width="550px" :close-on-click-modal="false">
            <el-form :model="addGroupMemberModel" :rules="addGroupMemberFormRules" ref="addGroupMemberForm" label-width="100px">
                <el-form-item label="部门：" prop="deptId">
                    <treeselect v-model="addGroupMemberModel.deptId" :options="deptOptions" @select="deptSelect" @open="deptOpen" :defaultExpandLevel="2"
                                :show-count="true" placeholder="请选择部门"/>
                </el-form-item>
                <el-form-item label="人员：" prop="userId">
                    <el-select ref="groupUserSelectRef" v-model="addGroupMemberModel.userId" clearable filterable placeholder="请选择人员" style="width: 100%">
                        <el-option v-for="item in userOptions"
                                :key="item.userId" :label="item.nickName+'（'+item.phonenumber+'）'" :value="item.userId"/>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearForm">取消</el-button>
                <el-button type="primary" @click="confirmAddGroupMember">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
  addMember,
  queryMemberList,
  removeMember,
} from "@/api/crm/contract";
import {listUserWithOutDataScope} from "@/api/system/user";
import Treeselect from "@riophae/vue-treeselect";
import UserAvatar from '@/views/system/user/userAvatar'
import {mapState} from 'vuex'

import {treeSelectWithOutDataScope} from "@/api/system/dept";
export default {
    name: 'AddMember',
    components: {
        Treeselect,
        UserAvatar
    },
    props: {
        addGroupMemberAuth: {
            type: Boolean,
            default: true
        },
        targetId: {},
        targetType: {},
        managerId: {}
    },
    data() {
        return {
            addGroupMemberVisible: false,
            groupMemberList: [],
            deptOptions: [],
            userOptions: [],
            addGroupMemberModel: {
                deptId: null,
                userId: null
            },
            addGroupMemberFormRules: {
                deptId: [
                    {required: true, message: '请选择部门', trigger: 'change'}
                ],
                userId: [
                    {required: true, message: '请选择人员', trigger: 'change'}
                ],
            },
        }
    },
    watch: {
        targetId (val) {
            if (val) {
                this.queryList();
            }
        },
        targetType (val) {
            if (val) {
                this.queryList();
            }
        },
    },
    mounted() {
        this.queryList()
        this.getTreeselect()
    },
    computed: {
        ...mapState({
            currentUserId: state => state.user.userId,
        })
    },
    methods: {
        queryList() {
            queryMemberList({
                targetId: this.targetId,
                targetType: this.targetType,
            }).then(response => {
                this.groupMemberList = response.data || []
                this.groupMemberList.forEach(item => {
                    item.removeGroupMemberAuth = false
                    // 是团队成员的就可以进行添加
                    if (this.currentUserId === item.userId) {
                        this.addGroupMemberAuth = true
                    }
                    // 只有商机负责人或者本人添加的可以移除
                    if (this.currentUserId === this.managerId || this.currentUserId === item.createBy) {
                        item.removeGroupMemberAuth = true
                    }
                })
            })
        },
        confirmAddGroupMember () {
            this.$refs["addGroupMemberForm"].validate(valid => {
                if (valid) {
                const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
                addMember({
                    ...this.addGroupMemberModel,
                    targetId: this.targetId,
                    targetType: this.targetType,
                }).then(response => {
                    // 刷新页面
                    this.$emit('success')
                    this.msgSuccess("操作成功");
                    this.queryList()
                    this.clearForm()
                    this.addGroupMemberVisible = false
                }).finally(() => {
                    loading.close()
                })
                }
            })
        },
        removeMember (member) {
            let that = this
            this.$confirm('确认移除该团队成员(' + member.nickName + ')吗？', '提示', {confirmButtonText: '确认'}).then(() => {
                const loading = that.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
                removeMember({
                    targetId: this.targetId,
                    targetType: this.targetType,
                    userId: member.userId
                }).then(response => {
                    // 如果删除的是自己，有可能就没有这个商机的查看权限了，重新查下详情接口
                    that.$emit('success')
                    // 刷新页面
                    that.queryList()
                    that.msgSuccess("操作成功");
                }).finally(() => {
                    loading.close()
                })
            }).catch(() => {
            });
        },
        /** 查询部门下拉树结构 */
        getTreeselect() {
            treeSelectWithOutDataScope().then(response => {
                this.deptOptions = response.data;
            });
        },
        deptSelect (node, instanceId) {
            this.userOptions = []
            this.addGroupMemberModel.userId = null
            listUserWithOutDataScope({deptId: node.id}).then(response => {
                this.userOptions = response.rows;
            });
        },
        deptOpen () {
            this.$refs.groupUserSelectRef.blur()
        },
        clearForm () {
            this.resetForm('addGroupMemberForm')
            this.addGroupMemberVisible = false
        },
    }
}
</script>
<style lang="scss" scoped>
.group-member-add-btn {
      width: 40px;
      height: 40px;
      text-align: center;
      border-radius: 50%;
      padding: 0 0 0 2px;
      position: absolute;
      top: -12px;
    }

    .group-member {
      width: 120px;
      margin-bottom: 20px;
      height: 40px;

      .avatar {
        float: left;
      }

      .name {
        margin-left: 45px;
        line-height: 50px;
        margin-top: -12px;
      }

      .value {
        width: 75px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .group-member-remove-btn {
        margin-left: -5px;
        cursor: pointer;
        position: absolute;
      }
    }
</style>